var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTteldLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 41829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3747 10.6946L19.4043 15.8306L10.3476 20L9.15533 20L-0.000337959 15.9016L-0.000338991 4.09835L9.15532 8.95994e-07L10.3451 7.91984e-07L19.325 4.1006L19.3747 10.6946ZM17.8212 9.10552L17.7691 5.13329L10.0076 1.58905L9.4867 1.58905L1.56889 5.13329L1.56889 9.10552L7.27141 9.10552L8.02844 6.95669L9.84532 6.95669L7.8341 13.174L6.06016 13.1705L6.81719 10.9474L1.56889 10.9474L1.56889 14.8667L9.4867 18.411L10.0076 18.411L17.8212 14.8138L17.7691 10.9474L11.8136 10.9474L11.1015 13.1705L9.08829 13.174L11.1015 6.93186L13.0249 6.93186L12.4192 9.10552L17.8212 9.10552Z",
    fill: "#F99E2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTteldLogo);
export default __webpack_public_path__ + "static/media/tteld_logo.cf40f55d60a3b6a69c20237f9dc3f8ff.svg";
export { ForwardRef as ReactComponent };